import React from 'react';

const Telecom = () => {
    return (
        <div className="industry-section">
            <div className="industry-content">
                <h2>Telecommunications</h2>
                <p>
                    Optimize your telecommunications infrastructure with our precision LiDAR mapping services. We provide detailed 3D models of terrain and structures to help plan optimal tower placement, analyze line-of-sight for wireless networks, and manage existing assets.
                </p>
                <p>
                    Our high-resolution data helps identify potential interference sources and optimize coverage while reducing deployment costs and improving network reliability.
                </p>
                <div className="industry-features">
                    <span className="feature-item">Tower Placement Optimization</span>
                    <span className="feature-item">Line-of-Sight Analysis</span>
                    <span className="feature-item">Coverage Mapping</span>
                    <span className="feature-item">Infrastructure Inspection</span>
                    <span className="feature-item">Asset Management</span>
                </div>
            </div>
            <div className="industry-image">
                <img src="/img/industries/telecom.png" alt="Telecommunications LiDAR Application" />
            </div>
        </div>
    );
};

export default Telecom;
